import React, { useEffect, useState } from 'react'
import Sidebar from '../../components/Sidebar/Sidebar';
import PreVisitNotes from '../../components/Notes/PrevisitNotes';
import PostVisitNotes from '../../components/Notes/PostvisitNotes';
import NotesHistory from '../../components/Notes/NotesHistory';
import Footer from '../../components/Footer/Footer';
import { createNote, deleteNote, getNotes } from '../../api/notesApi';

const Notes = () => {
    const [sidebarExpanded, setSidebarExpanded] = useState(true);
    const [date, setDate] = useState('');
    const [postVisitNote, setPostVisitNote] = useState('');
    const [preVisitNote, setPreVisitNote] = useState('');
    const [notesHistory, setNotesHistory] = useState([]);

    const user_id = localStorage.getItem("userId");

    useEffect(() => {
        fetchNotes();
    }, [])

    const fetchNotes = async () => {
            try {
                // call the API to get all notes
                const data = await getNotes(user_id);

                // format the date and get the content from the API
                const formatted = data.map(note => ({
                    appointment_date: new Date(note.appointment_date).toLocaleDateString(),
                    preVisitNote: note.preVisitNote,
                    postVisitNote: note.postVisitNote,
                    id: note.id,
                    user_id: user_id
                }))

                // set the notes history to the content
                setNotesHistory(formatted);
            } catch (err) {
                console.error('Failed to fetch notes:', err);
            }
    }

    // Handles saving notes
    const handleSaveNote = async () => {
        // if no date, pre visit note, or post visit note
        if (!date || !postVisitNote.trim() || !preVisitNote.trim()) {
            alert('Please fill in both the date, post-visit notes, and pre-visit notes.');
            return;
        }

        try {
            const newNote = await createNote({ user_id: user_id, preVisitNote: preVisitNote, postVisitNote: postVisitNote, appointment_date: date});

            setNotesHistory([...notesHistory, newNote])
        } catch (error) {
            console.error('Failed to save note: ', error);
        }

        setDate('');
        setPostVisitNote('');
        setPreVisitNote('');
    }

    const handleDeleteNote = async (id) => {
        try {
            await deleteNote(id);
            setNotesHistory(notesHistory.filter(note => note.id !== id));
        } catch (error) {
            console.error("Failed to delete note:", error);
        }
    }

    return (
        <div className={`ml-0 flex flex-col min-h-screen transition-all duration-300 bg-gray-100 ${sidebarExpanded ? 'md:ml-56' : 'md:ml-16'}`}>

            <Sidebar expanded={sidebarExpanded} setExpanded={setSidebarExpanded} />

            <div className="p-6 space-y-3">
                <h1 className="text-3xl font-bold text-[#04395b]">Create New Note</h1>

                <div className="mb-4 bg-white rounded-lg shadow p-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Appointment Date</label>
                    <input
                        type="date"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#04395b] focus:border-[#04395b]"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                    />
                </div>

                <PreVisitNotes value={preVisitNote} onChange={setPreVisitNote} />
                <PostVisitNotes value={postVisitNote} onChange={setPostVisitNote} />

                <button onClick={handleSaveNote} className="px-4 py-2 bg-[#04395b] text-white rounded hover:bg-[#032d45]">
                    Save Note
                </button>
                <NotesHistory notes={notesHistory} onDelete={handleDeleteNote} fetchNotes={fetchNotes} user_id={user_id} />
            </div>

            <Footer />
        </div>
    )
}

export default Notes